import { gsap } from 'gsap';
import ScrollTrigger from 'gsap/ScrollTrigger';
gsap.registerPlugin(ScrollTrigger);

export default class StoreContact {
  constructor(container) {
    this.container = container;
    this.heading = container.querySelector('.store-contact__heading');
    this.body = container.querySelector('.store-contact__body');
    this.photo = container.querySelector('.store-contact__photo');
    this.img = this.photo?.querySelector('img');
    this.cardBg = container.querySelector('.store-contact__card-bg');

    this.init();
  }

  init = () => {
    this.initCardBg();
    this.initTextReveals();
    this.initPhotoReveal();
  };

  initCardBg = () => {
    if (!this.cardBg) return;

    gsap.fromTo(
      this.cardBg,
      { scale: 1.6 },
      {
        scale: 1,
        ease: 'none',
        scrollTrigger: {
          trigger: this.container,
          start: 'top bottom',
          end: 'bottom top',
          
        },
      }
    );
  };

  initTextReveals = () => {
    const items = [this.heading, this.body].filter(Boolean);

    items.forEach((el, i) => {
      gsap.from(el, {
        opacity: 0,
        y: 30,
        duration: 0.8,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: el,
          start: 'top 88%',
          toggleActions: 'play none none none',
        },
        delay: i * 0.15,
      });
    });
  };

  initPhotoReveal = () => {
    if (!this.photo) return;

    gsap.fromTo(
      this.photo,
      { clipPath: 'inset(8% round 4px)', scale: 1.08 },
      {
        clipPath: 'inset(0% round 4px)',
        scale: 1,
        duration: 1.2,
        ease: 'power3.out',
        scrollTrigger: {
          trigger: this.photo,
          start: 'top 85%',
          toggleActions: 'play none none none',
        },
      }
    );

    if (this.img) {
      gsap.fromTo(
        this.img,
        { scale: 1.15 },
        {
          scale: 1,
          duration: 1.4,
          ease: 'power3.out',
          scrollTrigger: {
            trigger: this.photo,
            start: 'top 85%',
            toggleActions: 'play none none none',
          },
        }
      );
    }
  };
}
